export default "__VITE_ASSET__BXub07YZ__"